import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Roots from "./Roots";
import { useLayoutEffect, useState } from "react";
import Loader from "./Components/Loader";

import AdminListService from "./services/admin-list.service";
import secureLocalStorage from "react-secure-storage";
import NotFound from "./NotFound";

function App() {
  const [country, setCountry] = useState("");
  const [countryAllowed, setCountryAllowed] = useState([]);
  const router = createBrowserRouter([{ path: "*", element: <Roots /> }]);

  async function fetchCountry() {
    try {
      const res = await fetch("https://ipwho.is/");
      if (res?.ok) {
        const data = await res.json();
        secureLocalStorage.setItem("area", data?.country);
        const response = await AdminListService.getAllowedCountry();
        setCountryAllowed(response?.data || []);
        setCountry(data?.country); // e.g. "Pakistan"
        // const org = data.connection?.org || data.connection?.isp || "";
        // if (
        //   /vpn|hosting|cloud|ovh|aws|digitalocean|hetzner|choopa|m247/i.test(
        //     org
        //   )
        // ) {
        //   console.log("⚠️ Possible VPN/Hosting provider:", org);
        // } else {
        //   console.log("✅ Likely residential IP:", org);
        // }
      } else {
        setCountry("error");
      }
    } catch (err) {
      setCountry("error");
    }
  }
  useLayoutEffect(() => {
    secureLocalStorage.removeItem("area");
    fetchCountry();
  }, []);
  {
  }
  return country === "" ? (
    <Loader />
  ) : countryAllowed?.includes(country) || country === "United States" ? (
    <RouterProvider router={router} />
  ) : (
    <NotFound button={false} />
  );
}

export default App;
